import { doc, DocumentData, getFirestore, QueryDocumentSnapshot, WithFieldValue, collection, DocumentReference } from "firebase/firestore";


export type DocRef<T> = DocumentReference<T>;
export type DocSS<T> = QueryDocumentSnapshot<T>;

// FRONTEND FRONTEND FRONTEND
function FirestoreModel<T>() {
  class FirestoreModel {
    public id: string;
    public ref : DocumentReference<T>;

    public static pathToRef(refPath: string[]) {
      const db = getFirestore()
      return doc(db, refPath.join("/")).withConverter<T>(this);
    }
    public static pathToCollection(collectionPath: string[]) {
      const db = getFirestore()
      return collection(db, collectionPath.join("/")).withConverter<T>(this);
    }

    static fromFirestore<T>(snapshot: QueryDocumentSnapshot): T {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return new this(snapshot as any) as T;
    }

    static toFirestore<T extends FirestoreModel>(data: WithFieldValue<T>): DocumentData {
      return data;
    }

    constructor(snapshot: QueryDocumentSnapshot<T>) {
      this.id = snapshot.id;
      this.ref = snapshot.ref;
    }

    // public static refPath()
  }
  return FirestoreModel;
}
export default FirestoreModel;